// extracted by mini-css-extract-plugin
module.exports = {"banner-content":"style_banner-content__9-SCf","left":"style_left__2BlO2","right":"style_right__2RoGB"};